import { Component, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { loginUser } from '../redux/actions/user.actions';
import { AppState } from '../redux/app.state';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { firstValueFrom, Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnDestroy {
  img = `${environment.BACKEND}/images/logo.svg`;

  loginForm: UntypedFormGroup = new UntypedFormGroup({
    phone: new UntypedFormControl('0'),
    password: new UntypedFormControl('')
  });

  loading: boolean = false;

  authSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private store: Store<AppState>,
    private router: Router,
    private notificationService: NotificationService
  ) {
    this.authSubscription = this.authService.isAuth().subscribe((boolean) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      boolean && this.router.navigateByUrl('/');
    });
  }

  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }

  get phone() {
    return this.loginForm.controls.phone.value;
  }

  get password() {
    return this.loginForm.controls.password.value;
  }

  async login() {
    this.loading = true;
    try {
      const res = await firstValueFrom(this.authService.login(this.phone, this.password));
      this.loading = false;
      this.store.dispatch(
        loginUser({
          payload: {
            info: res.info
          }
        })
      );
      this.router.navigateByUrl('/');
    } catch (err) {
      this.notificationService.warning('Не верный логин или пароль!');
      this.loading = false;
    }
  }
}
